'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getLabelProps;
function getLabelProps(elements) {
    var props = {};

    props.text = elements.find(function (element) {
        return element.type === 'text';
    }).value;

    var spacing = elements.find(function (element) {
        return element.type === 'spacing';
    });

    if (spacing) {
        var before = spacing.elements.find(function (element) {
            return element.type === 'before';
        });

        if (before) {
            props.before = before.value;
        }

        var after = spacing.elements.find(function (element) {
            return element.type === 'after';
        });

        if (after) {
            props.after = after.value;
        }
    }

    var fontWeight = elements.find(function (element) {
        return element.type === 'fontWeight';
    });

    if (fontWeight) {
        props.forntWeight = fontWeight.value;
    }

    return props;
};